function propertiesSlider() {
    var propertiesList = document.querySelector('[data-module=properties-slider]')
    if (propertiesList) {
        document.addEventListener('click',function(e){
            if (e.target.getAttribute('data-slider-nav')) {
                var children = Array.prototype.slice.call(propertiesList.children)
                if (e.target.dataset.sliderNav == 'next') {
                    var offscreenNext = children.find(function(child) {
                        return child.offsetWidth + child.offsetLeft > propertiesList.offsetWidth + propertiesList.scrollLeft
                    })
                    // offscreenNext.scrollIntoView(false)
                    propertiesList.scrollLeft = offscreenNext.offsetLeft - propertiesList.offsetWidth + offscreenNext.offsetWidth
                } else {
                    children.reverse()
                    var offscreenPrev = children.find(function(child) {
                        return child.offsetLeft < propertiesList.scrollLeft
                    })
                    // offscreenPrev.scrollIntoView(false)
                    propertiesList.scrollLeft = offscreenPrev.offsetLeft
                }
            }
        })
        var sliderNextButton = document.querySelector('.slider-page-next')
        var sliderPrevButton = document.querySelector('.slider-page-prev')
        sliderPrevButton.toggleAttribute('disabled', propertiesList.scrollLeft === 0)
        sliderNextButton.toggleAttribute('disabled', propertiesList.scrollLeft + propertiesList.offsetWidth === propertiesList.scrollWidth)
        propertiesList.addEventListener('scroll', function(e) {
            sliderPrevButton.toggleAttribute('disabled', e.target.scrollLeft === 0)
            sliderNextButton.toggleAttribute('disabled', e.target.scrollLeft + e.target.offsetWidth === e.target.scrollWidth)
        })
    }
}

export default propertiesSlider